// extracted by mini-css-extract-plugin
export default {"Input":"DNAConcentrationCalculator_Input__Z-q0g","InputRow":"DNAConcentrationCalculator_InputRow__beR1X"};